import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { AuthGuard } from '@infra-adapters/guards/auth.guard';
import { RoleGuard } from '@infra-adapters/guards/role.guard';
import { UserRole } from '@core-interfaces/global';
import { ActiveSessionGuard } from '@infra-adapters/guards/activeSession.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: DefaultLayoutComponent,
    data: {
      title: 'Bienvenido',
    },
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        canActivate: [RoleGuard],
        data: { roles: [UserRole.Client] },
        loadChildren: () =>
          import('./views/dashboard/routes').then((m) => m.routes),
      },
      {
        path: 'survey',
        loadChildren: () =>
          import('./views/survey/routes').then((m) => m.routes),
      },
      {
        path: 'reward',
        loadChildren: () =>
          import('./views/reward/routes').then((m) => m.routes),
      },
      {
        path: 'user',
        loadChildren: () => 
          import('./views/user/routes').then((m) => m.routes),
      },
      {
        path: 'studies',
        loadChildren: () =>
          import('./views/studies/routes').then((m) => m.routes),
      },
      {
        path: 'giveaway',
        canActivate: [RoleGuard],
        data: { roles: [UserRole.Administrator] },
        loadChildren: () =>
          import('./views/giveaway/routes').then((m) => m.routes),
      }
    ],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/pages/page404/page404.component').then(
        (m) => m.Page404Component
      ),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./views/pages/page500/page500.component').then(
        (m) => m.Page500Component
      ),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    canActivate: [ActiveSessionGuard],
    loadComponent: () =>
      import('./views/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
    data: {
      title: 'Iniciar Sesión',
    },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./views/pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: {
      title: 'Register Page',
    },
  },
  {
    path: 'forgot_password',
    loadComponent: () => 
      import('./views/pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
    data: {
      title: 'Olvide mi contraseña'
    },
  },
  {
    path: 'set_new_password',
    loadComponent: () => 
      import('./views/pages/set-password/set-password.component').then(
        (m) => m.SetPasswordComponent
      ),
    data: {
      title: 'Establecer nueva contraseña'
    },
  },
  { path: '**', redirectTo: 'login' },
];
